export default routesHeader;

/** @ngInject */
function routesHeader($stateProvider) {
  $stateProvider
    .state('layout.header', {
      abstract: true,
      resolve: {
        schoolCommonRooms: SchoolCommonRoomService => SchoolCommonRoomService.getSchoolCommonRooms()
      }
    });
}
